var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamImg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_1774)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_91_1774",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_91_1774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0298 41.3931H3.68558C2.29214 41.3931 1.22656 40.3275 1.22656 38.9341V6.96683C1.22656 5.57338 2.29214 4.50781 3.68558 4.50781H43.0298C44.4233 4.50781 45.4889 5.57338 45.4889 6.96683V38.9341C45.4889 40.3275 44.4233 41.3931 43.0298 41.3931Z",
    fill: "#455A64",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0298 4.50781H3.68558C2.29214 4.50781 1.22656 5.57338 1.22656 6.96683V12.7046H45.4889V6.96683C45.4889 5.57338 44.4233 4.50781 43.0298 4.50781ZM3.68558 41.3931H43.0298C44.4233 41.3931 45.4889 40.3275 45.4889 38.9341V33.1964H1.22656V38.9341C1.22656 40.3275 2.29214 41.3931 3.68558 41.3931Z",
    fill: "#B0BEC5",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3111 41.3931H6.96683C5.57339 41.3931 4.50781 40.3275 4.50781 38.9341V6.96683C4.50781 5.57338 5.57339 4.50781 6.96683 4.50781H46.3111C47.7045 4.50781 48.7701 5.57338 48.7701 6.96683V38.9341C48.7701 40.3275 47.7045 41.3931 46.3111 41.3931Z",
    fill: "#546E7A",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14844 38.934V6.9668",
    stroke: "#78909C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3111 4.50781H6.96683C5.57339 4.50781 4.50781 5.57338 4.50781 6.96683V12.7046H48.7701V6.96683C48.7701 5.57338 47.7045 4.50781 46.3111 4.50781Z",
    fill: "#CFD8DC",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.474 10.6569H9.01498C8.52318 10.6569 8.19531 10.3291 8.19531 9.83728V7.37827C8.19531 6.88646 8.52318 6.55859 9.01498 6.55859H11.474C11.9658 6.55859 12.2937 6.88646 12.2937 7.37827V9.83728C12.2937 10.3291 11.9658 10.6569 11.474 10.6569ZM19.6707 10.6569H17.2117C16.7199 10.6569 16.392 10.3291 16.392 9.83728V7.37827C16.392 6.88646 16.7199 6.55859 17.2117 6.55859H19.6707C20.1625 6.55859 20.4904 6.88646 20.4904 7.37827V9.83728C20.4904 10.3291 20.1625 10.6569 19.6707 10.6569ZM27.8674 10.6569H25.4084C24.9166 10.6569 24.5888 10.3291 24.5888 9.83728V7.37827C24.5888 6.88646 24.9166 6.55859 25.4084 6.55859H27.8674C28.3592 6.55859 28.6871 6.88646 28.6871 7.37827V9.83728C28.6871 10.3291 28.3592 10.6569 27.8674 10.6569ZM36.0642 10.6569H33.6052C33.1133 10.6569 32.7855 10.3291 32.7855 9.83728V7.37827C32.7855 6.88646 33.1133 6.55859 33.6052 6.55859H36.0642C36.556 6.55859 36.8838 6.88646 36.8838 7.37827V9.83728C36.8838 10.3291 36.556 10.6569 36.0642 10.6569ZM44.2609 10.6569H41.8019C41.3101 10.6569 40.9822 10.3291 40.9822 9.83728V7.37827C40.9822 6.88646 41.3101 6.55859 41.8019 6.55859H44.2609C44.7527 6.55859 45.0806 6.88646 45.0806 7.37827V9.83728C45.0806 10.3291 44.7527 10.6569 44.2609 10.6569Z",
    fill: "#455A64",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96683 41.394H46.3111C47.7045 41.394 48.7701 40.3285 48.7701 38.935V33.1973H4.50781V38.935C4.50781 40.3285 5.57339 41.394 6.96683 41.394Z",
    fill: "#CFD8DC",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8019 35.2461H44.2609C44.7527 35.2461 45.0806 35.574 45.0806 36.0658V38.5248C45.0806 39.0166 44.7527 39.3445 44.2609 39.3445H41.8019C41.3101 39.3445 40.9822 39.0166 40.9822 38.5248V36.0658C40.9822 35.574 41.3101 35.2461 41.8019 35.2461ZM33.6052 35.2461H36.0642C36.556 35.2461 36.8838 35.574 36.8838 36.0658V38.5248C36.8838 39.0166 36.556 39.3445 36.0642 39.3445H33.6052C33.1133 39.3445 32.7855 39.0166 32.7855 38.5248V36.0658C32.7855 35.574 33.1133 35.2461 33.6052 35.2461ZM25.4084 35.2461H27.8674C28.3592 35.2461 28.6871 35.574 28.6871 36.0658V38.5248C28.6871 39.0166 28.3592 39.3445 27.8674 39.3445H25.4084C24.9166 39.3445 24.5888 39.0166 24.5888 38.5248V36.0658C24.5888 35.574 24.9166 35.2461 25.4084 35.2461ZM17.2117 35.2461H19.6707C20.1625 35.2461 20.4904 35.574 20.4904 36.0658V38.5248C20.4904 39.0166 20.1625 39.3445 19.6707 39.3445H17.2117C16.7199 39.3445 16.392 39.0166 16.392 38.5248V36.0658C16.392 35.574 16.7199 35.2461 17.2117 35.2461ZM9.01498 35.2461H11.474C11.9658 35.2461 12.2937 35.574 12.2937 36.0658V38.5248C12.2937 39.0166 11.9658 39.3445 11.474 39.3445H9.01498C8.52318 39.3445 8.19531 39.0166 8.19531 38.5248V36.0658C8.19531 35.574 8.52318 35.2461 9.01498 35.2461Z",
    fill: "#455A64",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8359 0.410156V2.86918M34.8359 5.73803V11.4757M34.8359 14.3446V19.2626",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14844 12.7045V6.9668M6.14844 38.934V33.1963",
    stroke: "#ECEFF1",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.125 39.3442V7.37695",
    stroke: "#455A64",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.125 12.7045V6.9668M47.125 39.3439V33.6062",
    stroke: "#90A4AE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3111 4.50781H6.96683C5.57339 4.50781 4.50781 5.57338 4.50781 6.96683V12.7046H48.7701V6.96683C48.7701 5.57338 47.7045 4.50781 46.3111 4.50781ZM6.96683 41.3931H46.3111C47.7045 41.3931 48.7701 40.3275 48.7701 38.9341V33.1964H4.50781V38.9341C4.50781 40.3275 5.57339 41.3931 6.96683 41.3931Z",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9006 30.8201L31.3924 32.7053L25.2449 17.9512C24.5891 16.3119 25.3269 14.3447 27.0482 13.6889L28.5236 13.0332L35.9006 30.8201Z",
    fill: "#78909C",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.308 30.656L33.2752 31.8855L27.1277 17.1314C26.472 15.492 27.2097 13.5248 28.931 12.8691L36.308 30.656Z",
    fill: "#B0BEC5",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9152 39.3447L36.3087 30.6562L31.3906 32.7053L37.0464 46.312C38.1939 49.0169 41.3087 50.3284 44.0136 49.1809C46.7185 48.0333 48.03 44.9186 46.8824 42.2136C45.7349 39.5087 42.6201 38.1971 39.9152 39.3447ZM43.03 46.8857C41.5546 47.4594 39.9152 46.8037 39.2595 45.3284C38.6857 43.853 39.3414 42.2135 40.8169 41.5578C42.2923 40.984 43.9316 41.6398 44.5873 43.1152C45.2431 44.5906 44.5054 46.3119 43.03 46.8857Z",
    fill: "#7F1767",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7656 30.8201L38.2738 32.7053L44.4214 17.9512C45.0771 16.3119 44.3394 14.3447 42.6181 13.6889L41.1427 13.0332L33.7656 30.8201Z",
    fill: "#78909C",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3594 30.656L36.3922 31.8855L42.5397 17.1314C43.1954 15.492 42.4577 13.5248 40.7364 12.8691L33.3594 30.656Z",
    fill: "#B0BEC5",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7835 42.2136C21.636 44.9186 22.9474 48.0333 25.6524 49.1809C28.3573 50.3284 31.472 49.0169 32.6196 46.312L38.2753 32.7053L33.3573 30.6562L29.7507 39.3447C27.0458 38.1971 23.931 39.5087 22.7835 42.2136ZM25.0786 43.1972C25.6524 41.7218 27.3737 41.0661 28.8491 41.6399C30.3245 42.2136 30.9802 43.935 30.4065 45.4104C29.8327 46.8857 28.1114 47.5415 26.636 46.9677C25.1606 46.312 24.4229 44.5907 25.0786 43.1972Z",
    fill: "#7F1767",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0827 35.9838C37.3462 35.9838 39.1811 34.1489 39.1811 31.8855C39.1811 29.622 37.3462 27.7871 35.0827 27.7871C32.8193 27.7871 30.9844 29.622 30.9844 31.8855C30.9844 34.1489 32.8193 35.9838 35.0827 35.9838Z",
    fill: "#7F1767",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6172 31.8848C32.6172 30.4913 33.6828 29.4258 35.0762 29.4258",
    stroke: "#F48FB1",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_1774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamImg5);
export default __webpack_public_path__ + "static/media/team_img5.0aa3d460419e4b55d4ec03ec518a7e18.svg";
export { ForwardRef as ReactComponent };